import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flipping-circle"
export default class extends Controller {
  connect() {
  }

  flip() {
    if (this.element.classList.contains('flipped')) {
      this.element.classList.remove('flipped');
    } else {
      this.element.classList.add('flipped');
    }
  }
}